import { beginTask, endTask } from 'redux-nprogress';
import { redirect } from 'redux-first-router';
// import { selectQuery } from '../../../../store/reducers/location.selectors';
import { ACCOUNT_INFORMATION_VIEW } from '../../AccountInfo/module/accountInfo';
import viewNames from '../../../../store/actions/view.types';
import routes from '../../../routes.global';

export const STORE_KEY = 'SetNewPassword';
export const selectResetNewPasswordState = state => state[STORE_KEY];

// ------------------------------------
// Reducer
// ------------------------------------
const actions = {};
const initialState = {
  error: null,
  email: null,
  key: null,
  password: null,
  submissionSuccess: null,
};

const resetPasswordReducer = (state = initialState, action) => {
  const handler = actions[action.type];
  return handler ? handler(state, action) : state;
};

export default resetPasswordReducer;

// ------------------------------------
// Actions
// ------------------------------------
export const SUBMIT_PASSWORD_RESET = `${STORE_KEY}/SUBMIT_PASSWORD_RESET`;
export const SUBMIT_PASSWORD_SUCCESS = `${STORE_KEY}/SUBMIT_PASSWORD_SUCCESS`;
export const SUBMIT_PASSWORD_ERROR = `${STORE_KEY}/SUBMIT_PASSWORD_ERROR`;
export const RESET_VIEW = `${STORE_KEY}/RESET_VIEW`;

export const resetView = () => ({
  type: RESET_VIEW,
});

export const submitPasswordError = error => ({
  type: SUBMIT_PASSWORD_ERROR,
  payload: { error },
});

export const submitPasswordSuccess = () => ({
  type: SUBMIT_PASSWORD_SUCCESS,
});

export const submitPasswordResetHere = (resetString, password) => ({
  type: SUBMIT_PASSWORD_RESET,
  payload: { resetString, password },
});

actions[RESET_VIEW] = state => ({ ...state,
  ...initialState,
});

actions[SUBMIT_PASSWORD_RESET] = (state, { payload }) => ({ ...state,
  key: payload.resetString,
  password: payload.password,
  error: null,
  submissionSuccess: null,
});

actions[SUBMIT_PASSWORD_ERROR] = (state, { payload }) => ({ ...state,
  error: payload.error,
  submissionSuccess: false,
});

actions[SUBMIT_PASSWORD_SUCCESS] = state => ({ ...state,
  error: null,
  submissionSuccess: true,
});


// ------------------------------------
// Submit key, new password for Password Reset
// ------------------------------------
export const handleSubmitPasswordReset = (newpassword) => async (dispatch, getState, { api }) => {
  const state = getState();
  const secret = state.location.payload.resetString;
  try {
    dispatch(beginTask());
    dispatch(submitPasswordResetHere(secret, newpassword));
    await api.user.submitPasswordReset({ secret, newpassword });
    dispatch(submitPasswordSuccess());
  } catch (error) {
    console.log('Error from call to api.user.getUserInfo:\n %O', error);
    dispatch(submitPasswordError(error));
  } finally {
    dispatch(endTask());
  }
};

// ------------------------------------
// View / Route
// ------------------------------------
export const RESET_PASSWORD_VIEW = `${STORE_KEY}/RESET_PASSWORD_VIEW`;
viewNames[RESET_PASSWORD_VIEW] = 'ResetPassword';
routes[RESET_PASSWORD_VIEW] = {
  path: '/reset-password/:resetString',
  thunk: async (dispatch, getState) => {
    const state = getState();
    const { loggedIn } = state.auth;
    if (loggedIn) {
      await dispatch(redirect({ type: ACCOUNT_INFORMATION_VIEW }));
    }
  },
};



// WEBPACK FOOTER //
// ./src/app/views/PasswordReset/module/resetPassword.js